import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductCutAsync,
  deleteProductCutAsync,
  editProductStyleAsync,
  editProductCutAsync,
  getProductStyleAsync,
  getProductCutAsync,
} from "../../../../store/services/productInfoServices";
const Cut = () => {
  const dispatch = useDispatch();
  const {
    getProductCutStatus,
    getProductCutError,
    getProductCutData,
    addProductCutStatus,
    addProductCutData,
    addProductCutError,

    editProductCutStatus,
    editProductCutError,
    editProductCutData,

    deleteProductCutData,
    deleteProductCutStatus,
    deleteProductCutError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductCutAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductCutData?.length
    ? getProductCutData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedCut, setSelectedCut] = useState();
  const [addCutMode, setAddCutMode] = useState(false);
  const [addCutData, setAddCutData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedCut", selectedCut);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductCutStatus === asyncStatus.SUCCEEDED) {
      setAddCutMode(false);
      setSaveDisabled(true);
      setAddCutData();
    }
  }, [, addProductCutStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductCutAsync(selectedCut?.cut_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductCutStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedCut();
    }
  }, [, deleteProductCutStatus]);
  useEffect(() => {
    if (editProductCutStatus === asyncStatus.SUCCEEDED) {
      setSelectedCut();
      setEditMode(false);
    }
  }, [, editProductCutStatus]);

  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this Cut?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Cut Name"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Cut Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddCutMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addCutMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addCutMode || !selectedCut}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddCutMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addCutMode || !selectedCut}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductCutStatus === asyncStatus.LOADING ||
                  editProductCutStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addCutData) {
                    dispatch(addProductCutAsync(addCutData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedCut, ...editData };
                    delete a.id;
                    dispatch(editProductCutAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack  height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "cut_id", headerName: "ID", flex: true },
                  { field: "cut_name", headerName: "Cut Name", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedCut(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductCutStatus === asyncStatus.IDLE ||
                  getProductCutStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addCutMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Cut:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddCutData({
                            ...addCutData,
                            cut_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddCutData({
                            ...addCutData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedCut ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedCut?.cut_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "Cut:",
                    comp: (
                      <InputComp
                        key={selectedCut?.cut_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            cut_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedCut?.cut_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={selectedCut?.is_active ? true : false}
                        defaultChecked={selectedCut?.is_active ? true : false}
                        checked={selectedCut?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any fit cut</Typography>
            )}
              <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductCutError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductCutError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductCutError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductCutError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  {
                    name: "Companies",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "companyId",
                              headerName: "Company ID",
                              flex: true,
                            },
                            {
                              field: "companyName",
                              headerName: "Company Name",
                              flex: true,
                            },
                            {
                              field: "action",
                              headerName: "Action",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedCut(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedCut(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default Cut;
